/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AiaRejectChangeOrderRequest,
  BadRequestResponse,
  BulkUpdateChangeOrderTaxRateResponse,
  ChangeOrderApprovalWorkflowResponse,
  ChangeOrderRecallPreviewResponse,
  ChangeOrdersAiaApprovalWorkflowGetV2Params,
  ChangeOrdersAiaRejectPostV2Params,
  ChangeOrdersRecallSelectionOptionsPreviewGetV2Params,
  CreateChangeOrderFromScheduleOfValuesRequest,
  CreateDraftChangeOrderResponse,
  ForbiddenResponse,
  ReadonlyProposalResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary This endpoint creates a change order with default values that will be able to be worked on 
by the internal user. This includes adding line items and changing content.
 */
export const changeOrdersCreateDraftByJobIdPostV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CreateDraftChangeOrderResponse>(
    {
      url: `/apix/v2/ChangeOrders/${jobId}/create-draft`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getChangeOrdersCreateDraftByJobIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOrdersCreateDraftByJobIdPostV2>>,
    TError,
    { jobId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeOrdersCreateDraftByJobIdPostV2>>,
  TError,
  { jobId: number },
  TContext
> => {
  const mutationKey = ["changeOrdersCreateDraftByJobIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeOrdersCreateDraftByJobIdPostV2>>,
    { jobId: number }
  > = (props) => {
    const { jobId } = props ?? {};

    return changeOrdersCreateDraftByJobIdPostV2(jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeOrdersCreateDraftByJobIdPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof changeOrdersCreateDraftByJobIdPostV2>>
>;

export type ChangeOrdersCreateDraftByJobIdPostV2MutationError =
  ErrorType<unknown>;

/**
 * @summary This endpoint creates a change order with default values that will be able to be worked on 
by the internal user. This includes adding line items and changing content.
 */
export const useChangeOrdersCreateDraftByJobIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOrdersCreateDraftByJobIdPostV2>>,
    TError,
    { jobId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeOrdersCreateDraftByJobIdPostV2>>,
  TError,
  { jobId: number },
  TContext
> => {
  const mutationOptions =
    getChangeOrdersCreateDraftByJobIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft` 

 Gated on ChangeOrders/Add rather than the SoV page's PurchaseOrders permission — the action creates a
change order. The manager additionally requires PurchaseOrders/View, since it reads the SoV.
 * @summary Creates a Prime AIA change order from the selected Schedule of Values line items and returns its id.
 */
export const changeOrdersCreateFromScheduleOfValuesByJobIdPostV2 = (
  jobId: number,
  createChangeOrderFromScheduleOfValuesRequest: BodyType<CreateChangeOrderFromScheduleOfValuesRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CreateDraftChangeOrderResponse>(
    {
      url: `/apix/v2/ChangeOrders/${jobId}/create-from-schedule-of-values`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: createChangeOrderFromScheduleOfValuesRequest,
      signal,
    },
    options,
  );
};

export const getChangeOrdersCreateFromScheduleOfValuesByJobIdPostV2MutationOptions =
  <
    TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof changeOrdersCreateFromScheduleOfValuesByJobIdPostV2>
      >,
      TError,
      {
        jobId: number;
        data: BodyType<CreateChangeOrderFromScheduleOfValuesRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof changeOrdersCreateFromScheduleOfValuesByJobIdPostV2>
    >,
    TError,
    {
      jobId: number;
      data: BodyType<CreateChangeOrderFromScheduleOfValuesRequest>;
    },
    TContext
  > => {
    const mutationKey = ["changeOrdersCreateFromScheduleOfValuesByJobIdPostV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof changeOrdersCreateFromScheduleOfValuesByJobIdPostV2>
      >,
      {
        jobId: number;
        data: BodyType<CreateChangeOrderFromScheduleOfValuesRequest>;
      }
    > = (props) => {
      const { jobId, data } = props ?? {};

      return changeOrdersCreateFromScheduleOfValuesByJobIdPostV2(
        jobId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangeOrdersCreateFromScheduleOfValuesByJobIdPostV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof changeOrdersCreateFromScheduleOfValuesByJobIdPostV2>
    >
  >;
export type ChangeOrdersCreateFromScheduleOfValuesByJobIdPostV2MutationBody =
  BodyType<CreateChangeOrderFromScheduleOfValuesRequest>;
export type ChangeOrdersCreateFromScheduleOfValuesByJobIdPostV2MutationError =
  ErrorType<BadRequestResponse | ForbiddenResponse>;

/**
 * @summary Creates a Prime AIA change order from the selected Schedule of Values line items and returns its id.
 */
export const useChangeOrdersCreateFromScheduleOfValuesByJobIdPostV2 = <
  TError = ErrorType<BadRequestResponse | ForbiddenResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof changeOrdersCreateFromScheduleOfValuesByJobIdPostV2>
    >,
    TError,
    {
      jobId: number;
      data: BodyType<CreateChangeOrderFromScheduleOfValuesRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof changeOrdersCreateFromScheduleOfValuesByJobIdPostV2>
  >,
  TError,
  {
    jobId: number;
    data: BodyType<CreateChangeOrderFromScheduleOfValuesRequest>;
  },
  TContext
> => {
  const mutationOptions =
    getChangeOrdersCreateFromScheduleOfValuesByJobIdPostV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const changeOrdersNotifyOwnersByChangeOrderIdPostV2 = (
  changeOrderId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/ChangeOrders/${changeOrderId}/notify-owners`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getChangeOrdersNotifyOwnersByChangeOrderIdPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOrdersNotifyOwnersByChangeOrderIdPostV2>>,
    TError,
    { changeOrderId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeOrdersNotifyOwnersByChangeOrderIdPostV2>>,
  TError,
  { changeOrderId: number },
  TContext
> => {
  const mutationKey = ["changeOrdersNotifyOwnersByChangeOrderIdPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeOrdersNotifyOwnersByChangeOrderIdPostV2>>,
    { changeOrderId: number }
  > = (props) => {
    const { changeOrderId } = props ?? {};

    return changeOrdersNotifyOwnersByChangeOrderIdPostV2(
      changeOrderId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeOrdersNotifyOwnersByChangeOrderIdPostV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof changeOrdersNotifyOwnersByChangeOrderIdPostV2>>
  >;

export type ChangeOrdersNotifyOwnersByChangeOrderIdPostV2MutationError =
  ErrorType<unknown>;

export const useChangeOrdersNotifyOwnersByChangeOrderIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOrdersNotifyOwnersByChangeOrderIdPostV2>>,
    TError,
    { changeOrderId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeOrdersNotifyOwnersByChangeOrderIdPostV2>>,
  TError,
  { changeOrderId: number },
  TContext
> => {
  const mutationOptions =
    getChangeOrdersNotifyOwnersByChangeOrderIdPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const changeOrdersDraftPreviewByChangeOrderIdGetV2 = (
  changeOrderId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ReadonlyProposalResponse>(
    {
      url: `/apix/v2/ChangeOrders/${changeOrderId}/draft-preview`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getChangeOrdersDraftPreviewByChangeOrderIdGetV2QueryKey = (
  changeOrderId?: number,
) => {
  return [`/apix/v2/ChangeOrders/${changeOrderId}/draft-preview`] as const;
};

export const getChangeOrdersDraftPreviewByChangeOrderIdGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  changeOrderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChangeOrdersDraftPreviewByChangeOrderIdGetV2QueryKey(changeOrderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>>
  > = ({ signal }) =>
    changeOrdersDraftPreviewByChangeOrderIdGetV2(
      changeOrderId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!changeOrderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangeOrdersDraftPreviewByChangeOrderIdGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>>
  >;
export type ChangeOrdersDraftPreviewByChangeOrderIdGetV2QueryError =
  ErrorType<unknown>;

export function useChangeOrdersDraftPreviewByChangeOrderIdGetV2<
  TData = Awaited<
    ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  changeOrderId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changeOrdersDraftPreviewByChangeOrderIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getChangeOrdersDraftPreviewByChangeOrderIdGetV2QueryOptions(
      changeOrderId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2 = (
  changeOrderId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<BulkUpdateChangeOrderTaxRateResponse>(
    {
      url: `/apix/v2/ChangeOrders/${changeOrderId}/bulk-update-tax-rate`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getChangeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2>
      >,
      TError,
      { changeOrderId: number },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2>
    >,
    TError,
    { changeOrderId: number },
    TContext
  > => {
    const mutationKey = ["changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2>
      >,
      { changeOrderId: number }
    > = (props) => {
      const { changeOrderId } = props ?? {};

      return changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2(
        changeOrderId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2>
    >
  >;

export type ChangeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2MutationError =
  ErrorType<unknown>;

export const useChangeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2>
    >,
    TError,
    { changeOrderId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof changeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2>
  >,
  TError,
  { changeOrderId: number },
  TContext
> => {
  const mutationOptions =
    getChangeOrdersBulkUpdateTaxRateByChangeOrderIdPostV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets the approval workflow for a Prime AIA change order's approval card.
 */
export const changeOrdersAiaApprovalWorkflowGetV2 = (
  params?: ChangeOrdersAiaApprovalWorkflowGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ChangeOrderApprovalWorkflowResponse>(
    {
      url: `/apix/v2/ChangeOrders/aia-approval-workflow`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getChangeOrdersAiaApprovalWorkflowGetV2QueryKey = (
  params?: ChangeOrdersAiaApprovalWorkflowGetV2Params,
) => {
  return [
    `/apix/v2/ChangeOrders/aia-approval-workflow`,
    ...(params ? [params] : []),
  ] as const;
};

export const getChangeOrdersAiaApprovalWorkflowGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: ChangeOrdersAiaApprovalWorkflowGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChangeOrdersAiaApprovalWorkflowGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>
  > = ({ signal }) =>
    changeOrdersAiaApprovalWorkflowGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangeOrdersAiaApprovalWorkflowGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>
>;
export type ChangeOrdersAiaApprovalWorkflowGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets the approval workflow for a Prime AIA change order's approval card.
 */

export function useChangeOrdersAiaApprovalWorkflowGetV2<
  TData = Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: ChangeOrdersAiaApprovalWorkflowGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changeOrdersAiaApprovalWorkflowGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChangeOrdersAiaApprovalWorkflowGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft` 

 Gated on View rather than Update: client approvers hold only View, and the manager rejects anyone
who isn't the active step's pending participant.
 * @summary Rejects the current user's active approval step, which declines the change order.
 */
export const changeOrdersAiaRejectPostV2 = (
  aiaRejectChangeOrderRequest: BodyType<AiaRejectChangeOrderRequest>,
  params?: ChangeOrdersAiaRejectPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/ChangeOrders/aia-reject`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: aiaRejectChangeOrderRequest,
      params,
      signal,
    },
    options,
  );
};

export const getChangeOrdersAiaRejectPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOrdersAiaRejectPostV2>>,
    TError,
    {
      data: BodyType<AiaRejectChangeOrderRequest>;
      params?: ChangeOrdersAiaRejectPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeOrdersAiaRejectPostV2>>,
  TError,
  {
    data: BodyType<AiaRejectChangeOrderRequest>;
    params?: ChangeOrdersAiaRejectPostV2Params;
  },
  TContext
> => {
  const mutationKey = ["changeOrdersAiaRejectPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeOrdersAiaRejectPostV2>>,
    {
      data: BodyType<AiaRejectChangeOrderRequest>;
      params?: ChangeOrdersAiaRejectPostV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return changeOrdersAiaRejectPostV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeOrdersAiaRejectPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof changeOrdersAiaRejectPostV2>>
>;
export type ChangeOrdersAiaRejectPostV2MutationBody =
  BodyType<AiaRejectChangeOrderRequest>;
export type ChangeOrdersAiaRejectPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Rejects the current user's active approval step, which declines the change order.
 */
export const useChangeOrdersAiaRejectPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeOrdersAiaRejectPostV2>>,
    TError,
    {
      data: BodyType<AiaRejectChangeOrderRequest>;
      params?: ChangeOrdersAiaRejectPostV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeOrdersAiaRejectPostV2>>,
  TError,
  {
    data: BodyType<AiaRejectChangeOrderRequest>;
    params?: ChangeOrdersAiaRejectPostV2Params;
  },
  TContext
> => {
  const mutationOptions =
    getChangeOrdersAiaRejectPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 */
export const changeOrdersRecallSelectionOptionsPreviewGetV2 = (
  params?: ChangeOrdersRecallSelectionOptionsPreviewGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ChangeOrderRecallPreviewResponse>(
    {
      url: `/apix/v2/ChangeOrders/recall-selection-options-preview`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getChangeOrdersRecallSelectionOptionsPreviewGetV2QueryKey = (
  params?: ChangeOrdersRecallSelectionOptionsPreviewGetV2Params,
) => {
  return [
    `/apix/v2/ChangeOrders/recall-selection-options-preview`,
    ...(params ? [params] : []),
  ] as const;
};

export const getChangeOrdersRecallSelectionOptionsPreviewGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ChangeOrdersRecallSelectionOptionsPreviewGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChangeOrdersRecallSelectionOptionsPreviewGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>>
  > = ({ signal }) =>
    changeOrdersRecallSelectionOptionsPreviewGetV2(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangeOrdersRecallSelectionOptionsPreviewGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>>
  >;
export type ChangeOrdersRecallSelectionOptionsPreviewGetV2QueryError =
  ErrorType<unknown>;

export function useChangeOrdersRecallSelectionOptionsPreviewGetV2<
  TData = Awaited<
    ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  params?: ChangeOrdersRecallSelectionOptionsPreviewGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof changeOrdersRecallSelectionOptionsPreviewGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getChangeOrdersRecallSelectionOptionsPreviewGetV2QueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
